import { StyledChatFooterNew } from './ChatFooterNew.styled';
import ChatInput from './components/ChatInput/ChatInput';
import { forwardRef, Dispatch, SetStateAction } from 'react';

interface Props {
    setMessages: Dispatch<SetStateAction<string[]>>;
    room: string; // Add the room prop
    chatUserIds: number[];
}

const ChatFooterNew = forwardRef((props: Props, ref) => {
    const { setMessages, room, chatUserIds } = props; // Extract the room prop

    return (
        <>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*// @ts-ignore*/}
            <StyledChatFooterNew ref={ref}>
                <ChatInput setMessages={setMessages} room={room} chatUserIds={chatUserIds} />{' '}
                {/* Pass the room prop */}
            </StyledChatFooterNew>
        </>
    );
});

export default ChatFooterNew;
